export default "__VITE_ASSET__BH9rxIG$__"